import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiMembersSkillEvaluationTermsShowType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiMembersSkillEvaluationTermsShowType> => {
  const response =
    await new ApiClient().get<ApiMembersSkillEvaluationTermsShowType>(
      `/api/members/skill_evaluation_terms/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersSkillEvaluationTermsShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMembersSkillEvaluationTermsShowType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersSkillEvaluationTermsShow", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
